import { blogLocaleFromPathname } from "@/lib/blog/locales";
import type { BlogLocaleNavigation } from "@/lib/blog/locale-navigation";
import { SITE_LOCALES } from "./config";
import { buildAlternateLocaleHref, buildLocalizedPath } from "./paths";

/** Site navigation always offers every public language; it is not an hreflang list. */
export function getLanguageSwitchOptions(pathname: string, navigation?: BlogLocaleNavigation | null) {
  const blog = navigation?.pathname === pathname.replace(/\/$/, "") ? navigation : null;
  const blogLocale = blogLocaleFromPathname(pathname);
  return SITE_LOCALES.map((locale) => ({
    locale,
    href: blog
      ? blog.hrefs[locale] ?? buildLocalizedPath({ locale, customPath: "home" })
      : blogLocale
        ? locale === blogLocale ? pathname : buildLocalizedPath({ locale, customPath: "home" })
        : buildAlternateLocaleHref(pathname, locale),
  }));
}
